// extracted by mini-css-extract-plugin
module.exports = {"mainButton":"button_mainButton__1nQMQ"};